import { IErrorsState } from './state';
import { ITraceableError } from '@/interfaces/Error';

import { EErrorExhibition, EErrorScope } from '@/helpers/enums';
import { traceError } from '@/helpers/errors';

export default {
  addError(state: IErrorsState, error: ITraceableError) {
    traceError(error);

    if (error.exhibition === EErrorExhibition.modal) {
      state.errors = state.errors.map((e: ITraceableError) => {
        return {
          ...e,
          ...e.exhibition === error.exhibition && { visibility: false },
        };
      });
    }

    state.errors.push(error);
  },
  hideError(state: IErrorsState, errorCode: string|number) {
    state.errors = state.errors.map((e: ITraceableError) => {
      return {
        ...e,
        ...e.code === errorCode && { visibility: false },
      };
    });
  },
  hideErrorsByScope(state: IErrorsState, scope: EErrorScope) {
    state.errors = state.errors.map((e: ITraceableError) => {
      return {
        ...e,
        ...e.scope === scope && { visibility: false },
      };
    });
  },
  removeError(state: IErrorsState, error: ITraceableError) {
    state.errors = state.errors.filter((e: ITraceableError) => e.exhibition !== error.exhibition);
  },
};
